import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconArrowUp: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.33333"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 12.6667V3.33333M12 7.33333L8 3.33333L4 7.33333"
    />
  </svg>
);

export {
  IconArrowUp,
};
